import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que restablece el scroll a la parte superior
 * cada vez que se cambia de ruta en la aplicación.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Cuando la ruta cambia, hacer scroll hacia arriba
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Este componente no renderiza nada
};

export default ScrollToTop; 